<template>
    <div v-if="shouldShow" class="site-alert relative text-center flex items-center pl-4 pr-8 z-40">
        <a class="text-primary-700 font-headline uppercase block text-center w-full relative z-10" :href="alert.href" target="_blank">
            <span class="block mx-auto font-bold leading-none" v-html="alert.text"></span>
        </a>
        <div class="backdrop absolute left-0 top-0 w-full h-full bg-secondary-500 pointer-events-none" aria-hidden="true"></div>
        <button @click="closeIt" class="alert-closer absolute appearance-none bg-transparent text-primary-700" aria-label="Close this alert">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';

export default {

    props: ['alert'],
    
    setup(props) {

        const shouldShow = ref(false);
        const cookie = props.alert.cookie;

        onMounted(() => {
            shouldShow.value = !(window.localStorage.getItem('last_saw_alert') === cookie);
        });

        const closeIt = () => {
            shouldShow.value = false;
            window.localStorage.setItem('last_saw_alert', cookie);
        };

        return {
            closeIt,
            shouldShow
        };

    }

}
</script>